import { t } from "i18next";
import { callApiV2 } from "../../util/apiCaller";
import { showNotification } from "../../util/Utility";
import { 
  FETCHING_MEMBER_LIST,
  FETCHING_MEMBER_LIST_SUCCESS,
  FETCHING_MEMBER_LIST_FAILURE,
  LOAD_USER_DASHBOARD_STATS, PASSWORD_CHANGE, PASSWORD_CHANGE_SUCCESS, UPDATE_CUSTOMER_FAILURE, UPDATE_USER, UPDATE_USER_FAILURE, UPDATE_USER_SUCCESS, 
  UPDATE_PAGE_FOR_MEMBER_INFO_LIST,
  RESET_LINK,
  RESET_LINK_SUCCESS,
  LOADING_MEMBER_REMINDER_HISTORY,
  LOAD_MEMBER_REMINDER_HISTORY} from "./userActionType";


export const fetchUserDashboardStats =
  (entity_id, userType) => async (dispatch) => {
    try {
        if(userType === "admin" || userType === "viewer"){
            if(entity_id == null){
                return
            }
        }
        if(!userType) return
        let payload ={
            "entity_id": entity_id,
            "role": userType
        }
        const res = await callApiV2({
          method: "post",
          endpoint: "user/dashboard/home",
          body: payload,
        });
        if (res?.status === "Success") {
          dispatch({
            type: LOAD_USER_DASHBOARD_STATS,
            dashboardStats: res.data,
          });
        }
    } catch (err) {
      console.log(err);
    }
  };

export const updateUserDetails =
    (id, details) => async (dispatch, getState) => {
      try {
        dispatch({
          type: UPDATE_USER,
          isFetching: true,
        });
        const res = await callApiV2({
          method: "post",
          endpoint: `user/${id}/update`,
          body: {
            user: details,
          },
          isErrorSuppressed: true,
        });
        console.log('details',details)
        if (res?.status === "Success") {
          showNotification("success", t("Profiel succesvol bijgewerkt."));
         
        } else {
          showNotification(
            "error",
            res?.data?.message || "Er is iets misgegaan.."
          );
          dispatch({
            type: UPDATE_USER_FAILURE,
            isFetching: false,
          });
        }
      } catch (err) {
        dispatch({
          type: UPDATE_USER_FAILURE,
          isFetching: false,
        });
      }
    };

export const ResetPassword = (resetLink, password) => async (dispatch, getState) => {
        try {
          dispatch({
            type: PASSWORD_CHANGE,
            isFetching: true,
          });
          let planDetails = getState()?.userReducer?.plans?.plan_details;
          if (planDetails) {
            const res = await callApiV2({
              method: "post",
              endpoint: `auth/reset-password/${resetLink}`,
              body: {
                admin: {
                  password: password,
                },
              },
            });
            if (res?.status === "Success") {
              dispatch({
                type: PASSWORD_CHANGE_SUCCESS,
                isFetching: false,
                isPasswordChange: true,
              });
              showNotification("success", "Wachtwoord succesvol gewijzigd.");
              // Logout and clear local storage
              localStorage.removeItem("token");
              localStorage.removeItem("userId");
              localStorage.removeItem("user_type");
              localStorage.removeItem("_expiredTime");
            } else {
              showNotification(
                "error",
                res?.data?.message || "Er is iets misgegaan.."
              );
              dispatch({
                type: PASSWORD_CHANGE,
                isFetching: false,
              });
            }
          }
        } catch (err) {
          dispatch({
            type: PASSWORD_CHANGE,
            isFetching: false,
          });
        }
      };

export const updatePageForMemberInfoList = (current) => ({
        type: UPDATE_PAGE_FOR_MEMBER_INFO_LIST,
        current,
      });
export const fetchMemberInfoList =(data) => async (dispatch, getState) => {
    try {
      dispatch({
        type: FETCHING_MEMBER_LIST,
        isFetching: true,
      });
        let pageNums = getState()?.userReducer?.memberInfo?.currentPage;
      let pageSize = getState()?.userReducer?.memberInfo?.pageSize;
      let payload = {
        entity_id:data?.entity_id,
        filters:data?.filters,
        isDeactivated:data?.isDeactivated,
        pageNum:pageNums,
        pageSize:pageSize,
        year: data?.year,
      }
     let endpoint = getState()?.appReducer?.userType === "product_owner"? `owner/organisations/members-list` :`admin/entity/${data?.entity_id}/customers-list`
      const res = await callApiV2({
        method: "post",
        endpoint: endpoint ,
        body:payload
      });
      if (res?.status === "Success") {
        dispatch({
          type: FETCHING_MEMBER_LIST_SUCCESS,
          list: res?.data?.list || [],
          count: res?.data?.count || 0,
          payments: res?.data?.payments || [],
          memberPayments: res?.data?.memberPayments || {},
          isFetching: false,
          pageNums,
          pageSize,
        });
      } else if (res?.status === "Error") {
        dispatch({
          type: FETCHING_MEMBER_LIST_FAILURE,
          isFetching: false,
        });
      }
    } catch (err) {
      showNotification("error", "Er is iets misgegaan..");
      dispatch({
        type: FETCHING_MEMBER_LIST_FAILURE,
        isFetching: false,
      });
    }
  };


export const forgetResetLink = (email) => async (dispatch, getState) => {
  try {
    dispatch({
      type: RESET_LINK,
      isFetching: true,
    });
    let planDetails = getState()?.ownerReducer?.plans?.plan_details;
    if (planDetails) {
      const res = await callApiV2({
        method: "post",
        endpoint: `auth/forgot-password`,
        body: {
            contact_email: email,
        },
        isErrorSuppressed: true,
      });
      if (res?.status === "Success") {
        dispatch({
          type: RESET_LINK_SUCCESS,
          isFetching: false,
          isResetLinkSend: true,
        });
        showNotification("success", "Reset link sent successfully.");
      } else {
        showNotification(
          "error",
          res?.data?.message || "Er is iets misgegaan.."
        );
        dispatch({
          type: RESET_LINK,
          isFetching: false,
        });
      }
    }
  } catch (err) {
    dispatch({
      type: RESET_LINK,
      isFetching: false,
    });
  }
};

export const fetchMemberReminderHistory =({ member_id, pageNum, pageSize }) => async (dispatch, getState) => {
    try {
      dispatch({
        type: LOADING_MEMBER_REMINDER_HISTORY,
        isFetching: true,
      });
      let query = `member/${member_id}/reminder-history`;
      const res = await callApiV2({
        method: "post",
        endpoint: `${query}`,
        body: {
          pageNum,
          pageSize,
        },
      });
      if (res?.status === "Success") {
        dispatch({
          type: LOAD_MEMBER_REMINDER_HISTORY,
          isFetching: false,
          reminder_history: res.data.tasks,
          total_reminder_count: res.data.total_count,
        });
      } else {
        dispatch({
          type: LOADING_MEMBER_REMINDER_HISTORY,
          isFetching: false,
        });
      }
    } catch (err) {
      dispatch({
        type: LOADING_MEMBER_REMINDER_HISTORY,
        isFetching: false,
      });
      showNotification("error", "Er is iets misgegaan..");
    }
  };
    